query AnalyticsSalesByUtm($filter: AnalyticsSalesFilterInput!, $dimension: UtmDimension!) {
  analyticsSales(filter: $filter) {
    currency
    salesByUtm(dimension: $dimension) {
      value
      sales
      revenue
    }
  }
}
